// @ts-nocheck

import React from 'react';
import cn from 'classnames';

import { isVariationV3Route } from '@shared/utils/general';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import styles from '../styles/AboutUs.module.css';

import { useAtomValue } from 'jotai';
import { dcbAtom, languageAtom } from '@shared/store/slice-atoms';
import { isID } from '@entities/country';

export const AboutUs = ({ tabIndex, aboutUsConfig = {} }) => {
  const { t } = useTranslation();
  const { hide, onlyLinks } = aboutUsConfig;
  const dcb = useAtomValue(dcbAtom);
  const language = useAtomValue(languageAtom);
  const isV3Route = isVariationV3Route(dcb.variationKey);

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear()?.toString() || '2025';

  // NOTE: Hide partner / ads / website links for Indonesia
  const hideLinks = isID(dcb?.homeData?.country) || language?.locale === 'id';

  if (hide || (onlyLinks && hideLinks)) {
    return null;
  }

  return (
    <Row className="mt-3">
      <Col xs={12}>
        {!onlyLinks ? (
          <>
            <p className={cn(styles.infoText, 'mb-2')}>
              {t('lost_travel_plans')}
              <br />
              <br />
              {t('cant_make_next_event')}
              <br />
              <br />
              {t('join_vuz')}
              <br />
              <br />
            </p>

            <p className={styles.infoTitle}> {t('about_vuz')}</p>
          </>
        ) : null}

        <div className={styles.infoText}>
          {!onlyLinks ? (
            <>
              {t('about_paragraph_1')}
              <br />
              <br />
              {t('about_paragraph_2')}
              <br />
              <br />
              {t('about_paragraph_3')}
              <br />
              <br />
              {t('about_paragraph_4')} <span className="fw-bold">{t('about_paragraph_5')}</span>
              <br />
              <br />
            </>
          ) : null}
          {!hideLinks ? (
            <div className={cn(isV3Route && 'vuz-links__wrapper')}>
              <div className={cn(isV3Route && 'vuz-links__container')}>
                <div>
                  {t('partner_with_us')}{' '}
                  <a href="mailto:partner@360mea.com" className={styles.infoLink}>
                    partner@360mea.com{' '}
                  </a>
                </div>
                <br />
                <div>
                  {t('advertise_with_us')}{' '}
                  <a href="mailto:ads@360mea.com" className={styles.infoLink}>
                    ads@360mea.com
                  </a>
                </div>
                <br />
                <div>
                  {t('our_official_website')}{' '}
                  <a
                    href="https://vuz.com/"
                    target="_blank"
                    className={styles.infoLink}
                    rel="noopener noreferrer"
                    tabIndex={tabIndex}
                  >
                    www.vuz.com
                  </a>
                </div>
                {isV3Route ? (
                  <div style={{ direction: 'ltr' }} className="vuz-copyright">
                    {`© Copyright 2024 VUZ`.replace('2024', currentYear)}
                  </div>
                ) : null}
              </div>
            </div>
          ) : null}
        </div>
      </Col>
    </Row>
  );
};
